import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import CustomInput from '../Component/CustomInput';
import CustomBanner from '../Component/custombaneer';
import INNER_BANNER from '../assets/imases/carrer.jpg';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { careerData } from '../redux/actions/action-creator';

const Career = () => {
    const dispatch = useDispatch();
    const [careerfrom, setCareerFrom] = useState({
        firstName: '',
        email: '',
        phone: '',
        city: '',
        position: '',
        educationalQualification: '',
        personalNote: '',
        resume: null,
    });

    // ✅ Validation
    const Validate_Function = (e) => {
        e.preventDefault();
        const { firstName, email, phone, city, position, educationalQualification, personalNote, resume } = careerfrom;

        if (!firstName.trim()) return toast.error('Please enter your first name');
        if (!email.trim()) return toast.error('Please enter your email');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailRegex.test(email.trim())) return toast.error('Invalid email format');
        if (!phone.trim()) return toast.error('Please enter your phone');
        const phoneRegex = /^[0-9]{10}$/;
        if (phone && !phoneRegex.test(phone.trim())) return toast.error('Phone number must be 10 digits');
        if (!city.trim()) return toast.error('Please enter your city');
        if (!position.trim()) return toast.error('Please enter your position');
        if (!educationalQualification.trim()) return toast.error('Please enter your educational qualification');
        if (!personalNote.trim()) return toast.error('Please enter your personal note');
        if (!resume) return toast.error('Please upload your resume');

        API_FUNCTION();
    };

    // ✅ API call
    const API_FUNCTION = () => {
        const { firstName, email, phone, city, position, educationalQualification, personalNote, resume } = careerfrom;

        const formData = new FormData();
        formData.append('firstName', firstName);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('city', city);
        formData.append('position', position);
        formData.append('educationalQualification', educationalQualification);
        formData.append('personalNote', personalNote);
        formData.append('resume', resume);

        dispatch(careerData(formData))
            .then((response) => {
                if (response?.status === 201) {
                    toast.success('Submitted successfully');
                    setCareerFrom({
                        firstName: '',
                        email: '',
                        phone: '',
                        city: '',
                        position: '',
                        educationalQualification: '',
                        personalNote: '',
                        resume: null,
                    });
                } else {
                    toast.error(response?.message || 'Submission failed');
                }
            })
            .catch((err) => toast.error(err?.message || 'Submission failed'));
    };

    // ✅ Label style (above inputs)
    const labelStyle = {
        fontSize: '1rem',
        fontWeight: 500,
        color: '#191a32',
        marginBottom: '6px',
        textAlign: 'left',
        display: 'block',
    };



    return (
        <>
            <CustomBanner
                imageUrl={INNER_BANNER}
                heading={'Work with us'}
                text={'Join Powerman’s Journey of Growth, Innovation, and Long-Term Success'}
                links={[
                    { label: 'Home', path: '/' },
                    { label: 'Career', path: '' }
                ]}
            />

            <Container fluid className="py-5" style={{ background: "transparent" }}>
                <div className="text-center mb-2" style={{ color: "#000000" }}>
                    What Are You Looking For In Your Next Job
                </div>
                <h1 className="text-center mb-5" style={{ color: "#191a32", fontWeight: 500 }}>
                    Apply Now For Success
                </h1>

                <div style={{ display: 'flex', justifyContent: 'center', width: "100%" }}>
                    <Form onSubmit={Validate_Function} className="mx-auto" style={{ width: '100%', maxWidth: "800px" }}>

                        {/* Row 1 */}
                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Label style={labelStyle}>First Name</Form.Label>
                                <CustomInput
                                    type="text"
                                    placeholder="Enter your first name"
                                    name="firstName"
                                    value={careerfrom.firstName}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, firstName: val })}
                                    style={{ height: 45, fontSize: 14 }}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label style={labelStyle}>Email</Form.Label>
                                <CustomInput
                                    type="email"
                                    placeholder="Enter your email"
                                    name="email"
                                    value={careerfrom.email}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, email: val })}
                                    style={{ height: 45, fontSize: 14 }}
                                />
                            </Col>
                        </Row>

                        {/* Row 2 */}
                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Label style={labelStyle}>Phone</Form.Label>
                                <CustomInput
                                    type="tel"
                                    placeholder="Enter your phone number"
                                    name="phone"
                                    value={careerfrom.phone}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, phone: val.replace(/[^0-9]/g, '') })}
                                    style={{ height: 45, fontSize: 14 }}
                                    maxLength={10}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label style={labelStyle}>City</Form.Label>
                                <CustomInput
                                    type="text"
                                    placeholder="Enter your city"
                                    name="city"
                                    value={careerfrom.city}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, city: val })}
                                    style={{ height: 45, fontSize: 14 }}
                                />
                            </Col>
                        </Row>

                        {/* Row 3 */}
                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Label style={labelStyle}>Position</Form.Label>
                                <CustomInput
                                    type="text"
                                    placeholder="Enter desired position"
                                    name="position"
                                    value={careerfrom.position}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, position: val })}
                                    style={{ height: 45, fontSize: 14 }}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label style={labelStyle}>Educational Qualification</Form.Label>
                                <CustomInput
                                    type="text"
                                    placeholder="Enter qualification"
                                    name="educationalQualification"
                                    value={careerfrom.educationalQualification}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, educationalQualification: val })}
                                    style={{ height: 45, fontSize: 14 }}
                                />
                            </Col>
                        </Row>

                        {/* Row 4 */}
                        <Row className="g-3 mb-4">
                            <Col md={6}>
                                <Form.Label style={labelStyle}>Upload Resume (PDF only)</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="application/pdf"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file && file.type === "application/pdf") {
                                            setCareerFrom({ ...careerfrom, resume: file });
                                        } else {
                                            toast.error("Only PDF files are allowed.");
                                            setCareerFrom({ ...careerfrom, resume: null });
                                        }
                                    }}
                                />
                            </Col>
                        </Row>

                        {/* Row 5 */}
                        <Row>
                            <Col md={12}>
                                <Form.Label style={labelStyle}>Personal Note</Form.Label>
                                <CustomInput
                                    as="textarea"
                                    rows={5}
                                    placeholder="Write something about yourself"
                                    name="personalNote"
                                    value={careerfrom.personalNote}
                                    onChange={(val) => setCareerFrom({ ...careerfrom, personalNote: val })}
                                    style={{ fontSize: 14 }}

                                />
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-end">
                            <Button
                                type="submit"
                                style={{
                                    background: "#e60000",
                                    border: "none",
                                    fontSize: "1.4rem",
                                    padding: "8px 48px",
                                    borderRadius: 4
                                }}
                            >
                                Submit &nbsp; →
                            </Button>
                        </div>
                    </Form>
                </div>
            </Container>
        </>
    );
};

export default Career;
